import React, { useEffect, useState } from "react";
import ProductsDesktop from "./ProductsDesktop";
import ProductsMobile from "./ProductsMobile";

export default function Products() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return <>{isMobile ? <ProductsMobile /> : <ProductsDesktop />}</>;
}
